import type React from "react";
import { SalesBoardPage } from "./SalesBoardPage";

/**
 * 営業管理ページのコンテナコンポーネント
 * @return {React.ReactElement} 営業管理ページ
 */
const SalesBoardPageContainer: React.FC = () => {
  return <SalesBoardPage />;
};

export default SalesBoardPageContainer;
